var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconApplicationEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M6.167 6.167a.833.833 0 1 1 0 1.666.833.833 0 0 1 0-1.666zm2.5 0H14.5a.833.833 0 0 1 0 1.666H8.667a.833.833 0 1 1 0-1.666zm-2.5 4.166a.833.833 0 1 1 0 1.667.833.833 0 0 1 0-1.667zm2.5 0h4.166a.833.833 0 1 1 0 1.667H8.667a.833.833 0 1 1 0-1.667zm-2.5 4.167a.833.833 0 1 1 0 1.667.833.833 0 0 1 0-1.667zm2.5 0h1.666a.833.833 0 1 1 0 1.667H8.667a.833.833 0 1 1 0-1.667zM17 3.667H3.667v16.666H17V19.5a.833.833 0 0 1 1.667 0v.833c0 .92-.747 1.667-1.667 1.667H3.667C2.747 22 2 21.254 2 20.333V3.667C2 2.747 2.746 2 3.667 2H17c.92 0 1.667.746 1.667 1.667V4.5A.833.833 0 1 1 17 4.5v-.833zm-.659 14.242l-3.96 1.296-.136-4.164 5.067-7.236a2 2 0 0 1 2.785-.491l.82.573a2 2 0 0 1 .49 2.786l-5.066 7.236zm3.21-8.943a.833.833 0 0 0-1.16.205l-4.462 6.37.045 1.389 1.32-.433 4.461-6.37a.833.833 0 0 0-.204-1.161zm-1.639.887l1.366.956-.956 1.365-1.366-.956.956-1.365z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#636176",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApplicationEdit);
export default __webpack_public_path__ + "static/media/icon-application-edit.804d565a8d3ddb3c27404aa0791b1264.svg";
export { ForwardRef as ReactComponent };